import React from 'react';

export function UserMap({
  notificationUsers = {},
  onNotificationUserFieldChange,
  onNotificationUserAdd,
  onNotificationUserRemove,
}) {
  return (
    <div style={{ gridColumn: '1/3' }}>
      <table className="table borders">
        <thead>
          <tr>
            <th colSpan={3}>Notification Users</th>
          </tr>
          <tr>
            <th>Name</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(notificationUsers).map(([name, email], index) => (
            <tr className="tr-action-td" key={index}>
              <td>
                <input
                  value={name}
                  onChange={(event) => onNotificationUserFieldChange(event, index, 'name')}
                />
              </td>
              <td style={{ borderRight: '0' }}>
                <input
                  value={email}
                  onChange={(event) => onNotificationUserFieldChange(event, index, 'email')}
                />
              </td>
              <td className="action-td">
                <i
                  className="fa-solid fa-minus fa-lg"
                  onClick={() => onNotificationUserRemove(index)}
                />
              </td>
            </tr>
          ))}
          <tr>
            <td className="add-row-button" colSpan={2} onClick={onNotificationUserAdd}>
              <i className="fa-sharp fa-solid fa-plus" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
